export const E_SPORTS_GROUP_ID = 2000077768
export const E_BASKETBALL_GROUP_ID = 2010203272
export const E_SOCCER_GROUP_ID = 2000124075

/** Helper to reformat any incorrect instances of eSports. E.g. |Esports Soccer|, Esports etc */
export const reformatSportsName = (name: string) => {
  if (name === '|Esports Soccer|') return 'eSports Soccer'

  const variations: string[] = ['esports', 'Esports', '|Esports|']

  const matched = variations.find(option => name.includes(option))

  if (!matched) {
    return name
  }

  return name.replace(matched, 'eSports').trim()
}
